import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import React from "react";
import TwoColumnLayout from "../../layout/TwoColumnLayout";
import { BookkeepingNewSection } from "bookkeeping/BookkeepingNewSection";
import { useLoaderData } from "react-router";

const BookkeepingNewApp = () => {
  const viewModel = useLoaderData<server.viewmodel.BookkeepingNewFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <BookkeepingNewSection />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <GeneralOptionsPanel
            links={[{
              text: RESX.Buttons.ListView,
              href: viewModel.listUrl,
              visible: true
            }]}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={site.navigation.rightSideNavigation.title}
      menuItems={site.navigation.rightSideNavigation.items}
      currentPage={site.currentPage}
    />
  </TwoColumnLayout>;
};

export default BookkeepingNewApp;